import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C23ContentFeedForLocalSiteProps } from './C23ContentFeedForLocalSite.types';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { ContentFeedWithFeaturedCardProps } from '@ahc-digital/component-library';
import { Link as JSSLink } from '@sitecore-jss/sitecore-jss-nextjs';

export function CreateContentFeedForLocalSiteModel(props?: C23ContentFeedForLocalSiteProps) {
  const { renderText, renderRichText, renderLink, renderImage } = useConditionalRendering();
  const { fields, params } = props || {};
  const articles = fields?.ContentWithFeaturedCard?.FeaturedCards?.articles;
  return {
    backgroundColor: getDroplink(params?.BackgroundColor, 'whiteSmoke'),
    contentAlignment: getDroplink(params?.ContentAlignment, 'center'),
    ctaAlignment: getDroplink(params?.CTAAlignment, 'center'),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    headline: renderText(fields?.ContentWithFeaturedCard?.Heading),
    supportCopy: renderRichText(fields?.ContentWithFeaturedCard?.SupportCopy),
    cta: renderLink(
      fields?.ContentWithFeaturedCard?.CTA
    ) as ContentFeedWithFeaturedCardProps['cta'],
    cards:
      ((articles?.length ?? 0) > 0 &&
        (articles?.map((article) => {
          const formattedDate = new Date(
            article?.fields?.PublishDate?.value ?? ''
          ).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          });
          return {
            date: formattedDate,
            image: renderImage(article?.fields?.FeaturedImage),

            link: (
              <JSSLink
                field={{
                  value: {
                    href: article.url,
                    text: article.fields?.Headline?.value,
                  },
                }}
              />
            ),
            excerpt: renderRichText(article?.fields?.Subheadline),
          };
        }) as ContentFeedWithFeaturedCardProps['cards'])) ||
      ([] as ContentFeedWithFeaturedCardProps['cards']),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
    placeholderImage: renderImage(fields?.ContentWithFeaturedCard?.PlaceholderImage),
  };
}
